import { render, staticRenderFns } from "./RSpreadsheet.vue?vue&type=template&id=f968eb7c&"
import script from "./RSpreadsheet.vue?vue&type=script&lang=js&"
export * from "./RSpreadsheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports